import * as React from "react";

import {
  PurchaseForm,
  useGiftcardPurchase,
  useReactGiftCardInitialState,
} from "../providers";

import { GiftcardProduct } from "./giftcard-product";

const oneFrameOfAnimation = 8;

export const BagModal: React.FunctionComponent = (props) => {
  const { initialState } = useReactGiftCardInitialState();
  const {
    reset,
    giftcardAddedToBag,
    scrollBackToTopOfThePage,
    onHasScrolledBackToTheTopOfThePage,
  } = useGiftcardPurchase();

  const [presentingProduct, setPresentingProduct] =
    React.useState<PurchaseForm | null>(null);
  const [presentingAnimationClass, setPresentingAnimationClass] =
    React.useState(false);
  const [
    presentingInnerContentAnimationClass,
    setPresentingInnerContentAnimationClass,
  ] = React.useState(false);

  const modalRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!giftcardAddedToBag && presentingProduct) {
      // close ->

      // animation
      setPresentingInnerContentAnimationClass(false);
      setTimeout(() => {
        setPresentingAnimationClass(false);
        setPresentingProduct(null);
      }, 299);

      // modal
      document.body.classList.remove("bbnt-modal-visible-scroll-that-only");
    } else if (
      giftcardAddedToBag &&
      presentingProduct &&
      giftcardAddedToBag !== presentingProduct
    ) {
      // override ->
      setPresentingProduct(giftcardAddedToBag);
      setTimeout(() => {
        setPresentingAnimationClass(true);

        setTimeout(() => {
          setPresentingInnerContentAnimationClass(true);
        }, oneFrameOfAnimation);
      }, oneFrameOfAnimation);
    } else if (
      giftcardAddedToBag &&
      presentingProduct &&
      giftcardAddedToBag === presentingProduct
    ) {
      // modal has rendered at least once ->

      document.body.classList.add("bbnt-modal-visible-scroll-that-only");
      modalRef.current?.focus();
    } else if (giftcardAddedToBag && !presentingProduct) {
      // open ->

      setPresentingInnerContentAnimationClass(false);
      setPresentingAnimationClass(false);
      setPresentingProduct(giftcardAddedToBag);
      setTimeout(() => {
        setPresentingAnimationClass(true);
        setTimeout(() => {
          setPresentingInnerContentAnimationClass(true);
        }, oneFrameOfAnimation);
      }, oneFrameOfAnimation);
    } /* if (!giftcardAddedToBag && !presentingProduct) */ else {
      // closed already -> noop, do nothing
    }
  }, [giftcardAddedToBag, presentingProduct]);

  React.useEffect(() => {
    if (!presentingProduct && scrollBackToTopOfThePage) {
      window.scrollTo({ top: 0, behavior: "auto" });
      onHasScrolledBackToTheTopOfThePage();
    }
  }, [presentingProduct, scrollBackToTopOfThePage]);

  const onCreateAnother = () => {
    reset();
  };

  if (!presentingProduct) {
    return null;
  }

  return (
    <aside
      className={`pdp-add-to-bag-modal-container ${
        presentingAnimationClass ? "show" : "hide"
      }`}
    >
      <div
        className={`overlay ${
          presentingInnerContentAnimationClass ? "show" : "hide"
        }`}
        onClick={onCreateAnother}
      ></div>
      <div
        className={`modal-content-container ${
          presentingInnerContentAnimationClass ? "show" : "hide"
        }`}
      >
        <div data-role="focusable-start" tabIndex={0}></div>
        <div className="modal-inner-wrap">
          <div className="close-button-container">
            <button className="close-button" onClick={onCreateAnother}></button>
          </div>
          <div className="modal-content">
            <section className="what-was-added-to-my-bag">
              <h2>1 item added to bag.</h2>
              <ul className="product-list readonly">
                <li>
                  <GiftcardProduct giftcardAddedToBag={presentingProduct} />
                </li>
              </ul>
              <div className="what-was-added-to-my-bag-actions">
                <a
                  className="view-bag-and-checkout"
                  href={initialState.checkout_url}
                >
                  <button>VIEW BAG AND CHECKOUT</button>
                </a>
                <button
                  className="create-another-e-gift-card"
                  onClick={onCreateAnother}
                >
                  Create Another E-Gift Card
                </button>
              </div>
            </section>
          </div>
        </div>
        <div data-role="focusable-end" tabIndex={0}></div>
      </div>
    </aside>
  );
};
